import { Navigate, useNavigate, useRoutes } from "react-router-dom";

// layouts
import DashboardLayout from "./layouts/dashboard";
import LogoOnlyLayout from "./layouts/LogoOnlyLayout";
//
import Login from "./pages/Login";
import Register from "./pages/Register";
import DashboardApp from "./pages/DashboardApp";
import Products from "./pages/Products";
import Blog from "./pages/Blog";
import User from "./pages/User";
import State from "./pages/State";
import City from "./pages/City";
import NotFound from "./pages/Page404";
import Country from "./pages/Country";
import Landmark from "./pages/Landmark";
import Event from "./pages/Event";
import Chapter from "./pages/Chapter";
import Member from "./pages/Member";
import Meeting from "./pages/Meeting";
import Setting from "./pages/Setting";
import LvbRecordsDynamic from "./pages/LvbRecordsDynamic";
import Poll from "./pages/Poll";
import Gallery from "./pages/gallery";
import V2v from "./pages/v2v";
import V2vReport from "./pages/v2vReport";
import Business from "./pages/Business";
import Reference from "./pages/Reference";
import Attendace from "./pages/Attendance";
import Memberattendace from "./pages/Memberattendance";
import Visitor from "./pages/Visitor";
import Greeting from "./pages/Greeting";
import Staff from "./pages/staff";
import FollowupLeads from "./pages/FollowupLeads";
import Lead from "./pages/lead";
import InquiryForm from "./pages/InquiryForm";
import CityAmbassador from "./pages/CityAmbassador";
import WalletHistory from "./pages/WalletHistory";
import LvbDocuments from "./pages/LvbDocuments";
import Bankdetail from "./pages/BankDetail";
import ChangePassword from "./pages/ChangePassword";
import Testimonial from "./pages/Testimonial";
import BusinessReport from "./pages/BusinessReport";
import ReferenceReport from "./pages/ReferenceReport";
import VisitorReport from "./pages/VisitorReport";
import TestimonialReport from "./pages/TestimonialReport";
import AttendaceReport from "./pages/AttendanceReport";
import LvbReport from "./pages/lvbreport";
import CityReport from "./pages/cityreport";
import CityChapterReport from "./pages/Citychapterreport";
import ChapterAttendanceReport from "./pages/Memberattendance";
import ExportReport from "./pages/ExportReport";
import GeneralReport from "./pages/ExportReport";
import ChapterV2vReport from "./pages/Chapterv2vreport";
import ChapterReport from "./pages/ChapterReport";
import LvbPinBadge from "./pages/LvbPinBadge";
import AchievementPinBadge from "./pages/AchievementPinBadge";
import MembershipFlow from "./pages/MembershipFlow";
import Magazine from "./pages/Magazine";
import ChapterMemberReportAllInOne from "./pages/ChapterMemberReportAllInOne";
import VisitorBlock from "./pages/VisitorBlackList";
import LeadForm from "./pages/LeadForm";
import InvoiceDownloadForm from "./pages/InvoiceDownloadForm";
import { Suggestion } from "./pages/Suggestion";
import MemberInductionReport from "./pages/MemberInductionReport";
import ThankyouNoteApproval from "./pages/WaitingBusinessApproval";
import PinAssignReport from "./pages/PinAssignReport";
import Notification from "./pages/Notification";
import TrainingAndWebinar from "./pages/TrainingAndWebinar";
import MeetingFeedbackFor from "./pages/MeetingFeedbackFor";
import MeetingFeedbackReport from "./pages/MeetingFeedbackReport";
import RenewalFollowupReport from "./pages/RenewalFollowupReport";
import ChapterDirectors from "./pages/ChapterDirectors";
import MembersV2VSheetReport from "./pages/MembersV2VSheetReport";
import MemberV2VSheet from "./pages/MemberV2VSheet";
import DescriptionEdit from "./pages/DescriptionEdit";
import AskReasons from "./pages/AskReasons";
import Asks from "./pages/Asks";
import V2VRejectReason from "./pages/V2VRejectReason";
import V2VDataList from "./pages/V2VDataList";
import BlueTickRejectReason from "./pages/BlueTickRejectReason";
import AddMGT from "./pages/AddMGT";
import BlueTickApplyList from "./pages/BlueTickApplyList";
import MgtQuestions from "./pages/MgtQuestions";
import LeadRejectReason from "./pages/LeadRejectReason";
import OBTRejectReason from "./pages/OBTRejectReason";
import OBTQuestions from "./pages/OBTQuestions";
import OBTAdd from "./pages/OBTAdd";
import OBTApply from "./pages/OBTApply";
import MemberDeactivateReason from "./pages/MemberDeactivateReason";
import RoutesView from "./pages/RoutesView";
import HowToUseApplicationView from "./pages/HowToUseApplicationView";
import MemberBlockList from "./pages/MemberBlockList";
import ProductsRoutes from "./pages/StockManagement/Products/index";
import SendTypeRoutes from "./pages/StockManagement/SendType/index";
import PaymentMethod from "./pages/PaymentMethod/index";
import Customer from "./pages/Customer/index";
import Product from "./pages/Product/index";
import CityStockRoutes from "./pages/StockManagement/CityStockReport/index";
import PendingStockRoutes from "./pages/StockManagement/PendingStock/index";
import ProductHistoryRoutes from "./pages/StockManagement/Products/productHistory";
import PinInMemberRoutes from "./pages/StockManagement/PinInMember/index";
import WalletRoutes from "./pages/StockManagement/Wallet/index";
import Invoice from "./pages/Invoice/index";
import AddInvoice from "./pages/Invoice/AddInvoice";
import WalletHistoryRoutes from "./pages/StockManagement/Wallet/stockWalletHistory";
import MemberListRoutes from "./pages/StockManagement/Products/memberList";
import Traveling from "./pages/Traveling";
import LeadStatus from "./pages/LeadStatus/index";
import TravelingPurpose from "./pages/TravelingPurpose";
import SystemLog from "./pages/SystemLog";
import CitySupportList from "./pages/CitySupportList";
import CitySupportForm from "./pages/CitySupportForm";
import AdminCitySupportList from "./pages/AdminCitySupportList";
import Page404 from "./pages/Page404";
import RolesListPage from "./pages/RolesListPage";
import AllocatePostPage from "./pages/AllocatePostPage";

// ----------------------------------------------------------------------
export function AuthRouter() {
  return useRoutes([
    {
      path: "/*",
      element: <LogoOnlyLayout />,
      children: [
        { path: "login", element: <Login /> },
        { path: "*", element: <Login /> },
        { path: "inquiry-form/:c_id", element: <InquiryForm /> },
        { path: "inquiry-form", element: <InquiryForm /> },
        { path: "invoice-download-form/:l_id", element: <InvoiceDownloadForm /> },
        { path: "lvb-membership-form/:cityname/:c_id", element: <LeadForm /> },
        { path: "lvb-membership-form/*", element: <LeadForm /> },
        { path: "404", element: <Page404 /> }
      ]
    }
  ]);
}
export function Router() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));

  const navigate = useNavigate();

  return useRoutes([
    {
      path: "/*",
      element: <LogoOnlyLayout />,
      children: [{ path: "inquiry-form", element: <InquiryForm /> }]
    },
    {
      path: "/*",
      element: <LogoOnlyLayout />,
      children: [{ path: "invoice-download-form/:l_id", element: <InvoiceDownloadForm /> }]
    },
    {
      path: "/*",
      element: <LogoOnlyLayout />,
      children: [
        { path: "inquiry-form/:c_id", element: <InquiryForm /> },
        { path: "inquiry-form", element: <InquiryForm /> },
        { path: "invoice-download-form/:l_id", element: <InvoiceDownloadForm /> }
      ]
    },
    {
      path: "/*",
      element: <DashboardLayout />,
      children:
        // Admin Routes

        loginUser?.u_type == 0 ||
          (loginUser?.u_type == 2 &&
            loginUser?.p_user_id == 1 &&
            (loginUser?.management_p != 0 || loginUser?.is_subadmin == 1))
          ? [
            { path: "*", element: <DashboardApp /> },
            {
              path: "dashboard",
              exact: true,
              strict: true,
              element: <DashboardApp />
            },
            {
              path: "documents",
              exact: true,
              strict: true,
              element: <LvbDocuments />
            },
            {
              path: "wallethistory/:c_a_id",
              exact: true,
              strict: true,
              element: <WalletHistory />
            },
            {
              path: "country",
              exact: true,
              strict: true,
              element: <Country />
            },
            { path: "state", exact: true, strict: true, element: <State /> },
            { path: "city", exact: true, strict: true, element: <City /> },
            {
              path: "cityambassador",
              exact: true,
              strict: true,
              element: <CityAmbassador />
            },
            {
              path: "landmark",
              exact: true,
              strict: true,
              element: <Landmark />
            },
            {
              path: "event-announcement",
              exact: true,
              strict: true,
              element: <Event />
            },
            {
              path: "visitor",
              exact: true,
              strict: true,
              element: <Visitor />
            },
            {
              path: "testimonial",
              exact: true,
              strict: true,
              element: <Testimonial />
            },
            {
              path: "greeting",
              exact: true,
              strict: true,
              element: <Greeting />
            },
            {
              path: "chapter",
              exact: true,
              strict: true,
              element: <Chapter />
            },
            {
              path: "member",
              exact: true,
              strict: true,
              element: <Member />
            },
            {
              path: "member-deactivate-reason",
              exact: true,
              strict: true,
              element: <MemberDeactivateReason />
            },
            {
              path: "meeting",
              exact: true,
              strict: true,
              element: <Meeting />
            },
            {
              path: "meetingfeedbackfor",
              exact: true,
              strict: true,
              element: <MeetingFeedbackFor />
            },
            {
              path: "traveling-purpose",
              exact: true,
              strict: true,
              element: <TravelingPurpose />
            },
            {
              path: "lvb-records-dynamic",
              exact: true,
              strict: true,
              element: <LvbRecordsDynamic />
            },
            {
              path: "setting",
              exact: true,
              strict: true,
              element: <Setting />
            },
            {
              path: "payment-method",
              exact: true,
              strict: true,
              element: <PaymentMethod />
            },
            {
              path: "customer",
              exact: true,
              strict: true,
              element: <Customer />
            },
            {
              path: "product",
              exact: true,
              strict: true,
              element: <Product />
            },
            {
              path: "paid-invoice",
              exact: true,
              strict: true,
              element: <Invoice />
            },
            {
              path: "quotation-invoice",
              exact: true,
              strict: true,
              element: <Invoice />
            },
            {
              path: "add-invoice",
              exact: true,
              strict: true,
              element: <AddInvoice />
            },
            {
              path: "edit-invoice",
              exact: true,
              strict: true,
              element: <AddInvoice />
            },
            {
              path: "add-quotation",
              exact: true,
              strict: true,
              element: <AddInvoice />
            },
            {
              path: "edit-quotation",
              exact: true,
              strict: true,
              element: <AddInvoice />
            },
            {
              path: "description-edit",
              exact: true,
              strict: true,
              element: <DescriptionEdit />
            },
            { path: "poll", exact: true, strict: true, element: <Poll /> },
            // {
            //   path: "gallery",
            //   exact: true,
            //   strict: true,
            //   element: <Gallery />
            // },
            { path: "v2v", exact: true, strict: true, element: <V2v /> },
            { path: "*", exact: true, strict: true, element: <Chapter /> },
            {
              path: "business",
              exact: true,
              strict: true,
              element: <Business />
            },
            {
              path: "reference",
              exact: true,
              strict: true,
              element: <Reference />
            },
            {
              path: "attendace/:m_id",
              exact: true,
              strict: true,
              element: <Attendace />
            },

            (loginUser?.u_type == 0 ||
              loginUser?.management_p != 0 ||
              (loginUser?.u_type == 2 &&
                loginUser?.p_user_id == 1 &&
                loginUser?.is_subadmin == 1)) && {
              path: "staff",
              exact: true,
              strict: true,
              element: <Staff />
            },
            { path: "followup-leads", exact: true, strict: true, element: <FollowupLeads /> },
            { path: "lead", exact: true, strict: true, element: <Lead /> },
            {
              path: "lead-reject-reason",
              exact: true,
              strict: true,
              element: <LeadRejectReason />
            },
            {
              path: "v2v-report",
              exact: true,
              strict: true,
              element: <V2vReport />
            },
            {
              path: "memberv2vsheet/:member_id",
              exact: true,
              strict: true,
              element: <MemberV2VSheet />
            },
            {
              path: "business-report",
              exact: true,
              strict: true,
              element: <BusinessReport />
            },
            {
              path: "reference-report",
              exact: true,
              strict: true,
              element: <ReferenceReport />
            },
            {
              path: "visitorreport",
              exact: true,
              strict: true,
              element: <VisitorReport />
            },
            {
              path: "testimonial-report",
              exact: true,
              strict: true,
              element: <TestimonialReport />
            },
            {
              path: "attendance-report",
              exact: true,
              strict: true,
              element: <AttendaceReport />
            },
            // Meeting Feedback Report
            {
              path: "meeting-feedback-report",
              exact: true,
              strict: true,
              element: <MeetingFeedbackReport />
            },
            // Renewal Follow-up (Admin view-only)
            {
              path: "renewal-followup",
              exact: true,
              strict: true,
              element: <RenewalFollowupReport />
            },
            // Director Management — shim per §5: redirects to Chapter list (will be deleted next release)
            {
              path: "director-management",
              exact: true,
              strict: true,
              element: <Navigate to="/chapter" replace />
            },
            {
              path: "chapter-directors/:chapterId",
              exact: true,
              strict: true,
              element: <ChapterDirectors />
            },
            {
              path: "members-v2v-sheet-report",
              exact: true,
              strict: true,
              element: <MembersV2VSheetReport />
            },
            // LVB Report
            {
              path: "lvb-report",
              exact: true,
              strict: true,
              element: <LvbReport />
            },
            // City Report
            {
              path: "city-report",
              exact: true,
              strict: true,
              element: <CityReport />
            },
            {
              path: "city-chapter-report",
              exact: true,
              strict: true,
              element: <CityChapterReport />
            },
            // Chapter Report
            {
              path: "chapter-v2v-report",
              exact: true,
              strict: true,
              element: <ChapterV2vReport />
            },
            {
              path: "chapter-business-report",
              exact: true,
              strict: true,
              element: <BusinessReport />
            },
            {
              path: "chapter-reference-report",
              exact: true,
              strict: true,
              element: <ReferenceReport />
            },
            {
              path: "chapter-visitor-report",
              exact: true,
              strict: true,
              element: <VisitorReport />
            },
            {
              path: "chapter-testimonial-report",
              exact: true,
              strict: true,
              element: <TestimonialReport />
            },
            {
              path: "chapter-attendance-report",
              exact: true,
              strict: true,
              element: <ChapterAttendanceReport />
            },
            {
              path: "visitor-block-list",
              exact: true,
              strict: true,
              element: <VisitorBlock />
            },
            {
              path: "member-block-list",
              exact: true,
              strict: true,
              element: <MemberBlockList />
            },
            {
              path: "lvb-suggestion",
              exact: true,
              strict: true,
              element: <Suggestion />
            },
            {
              path: "lvb-notification",
              exact: true,
              strict: true,
              element: <Notification />
            },
            {
              path: "chapters-member-report",
              exact: true,
              strict: true,
              element: <ChapterMemberReportAllInOne />
            },
            {
              path: "chapter-attendance-report",
              exact: true,
              strict: true,
              element: <ChapterAttendanceReport />
            },
            {
              path: "topper-report",
              exact: true,
              strict: true,
              element: <GeneralReport />
            },
            {
              path: "lvb-pin-badge",
              exact: true,
              strict: true,
              element: <LvbPinBadge />
            },
            {
              path: "achievement-pin-badge",
              exact: true,
              strict: true,
              element: <AchievementPinBadge />
            },
            {
              path: "training-webinar",
              exact: true,
              strict: true,
              element: <TrainingAndWebinar />
            },
            {
              path: "membership-flow",
              exact: true,
              strict: true,
              element: <MembershipFlow />
            },
            {
              path: "magazine",
              exact: true,
              strict: true,
              element: <Magazine />
            },
            {
              path: "member-induction-report",
              exact: true,
              strict: true,
              element: <MemberInductionReport />
            },
            {
              path: "pin-assign-report",
              exact: true,
              strict: true,
              element: <PinAssignReport />
            },
            {
              path: "business-approval",
              exact: true,
              strict: true,
              element: <ThankyouNoteApproval />
            },
            {
              path: "ask-reasons",
              exact: true,
              strict: true,
              element: <AskReasons />
            },
            {
              path: "asks",
              exact: true,
              strict: true,
              element: <Asks />
            },
            {
              path: "v2v-reject-reasons",
              exact: true,
              strict: true,
              element: <V2VRejectReason />
            },
            {
              path: "v2vlist",
              exact: true,
              strict: true,
              element: <V2VDataList />
            },
            {
              path: "bluetick-reject-reasons",
              exact: true,
              strict: true,
              element: <BlueTickRejectReason />
            },
            {
              path: "mgt-questions",
              exact: true,
              strict: true,
              element: <MgtQuestions />
            },
            {
              path: "addmgt",
              exact: true,
              strict: true,
              element: <AddMGT />
            },
            {
              path: "bluetick-apply",
              exact: true,
              strict: true,
              element: <BlueTickApplyList />
            },
            {
              path: "obt-reject-reasons",
              exact: true,
              strict: true,
              element: <OBTRejectReason />
            },
            {
              path: "obt-questions",
              exact: true,
              strict: true,
              element: <OBTQuestions />
            },
            {
              path: "obt-add",
              exact: true,
              strict: true,
              element: <OBTAdd />
            },
            {
              path: "obt-apply",
              exact: true,
              strict: true,
              element: <OBTApply />
            },
            // { path: "chapter-report", element: <ChapterReport /> }
            {
              path: "city-support",
              exact: true,
              strict: true,
              element: <AdminCitySupportList />
            },
            {
              path: "city-support/add",
              exact: true,
              strict: true,
              element: <CitySupportForm />
            },
            {
              path: "city-support/list/:cityId",
              exact: true,
              strict: true,
              element: <CitySupportList />
            },
            {
              path: "city-support/edit/:id",
              exact: true,
              strict: true,
              element: <CitySupportForm />
            },
            {
              path: "routes-view",
              exact: true,
              strict: true,
              element: <RoutesView />
            },
            {
              path: "roles",
              exact: true,
              strict: true,
              element: <RolesListPage />
            },
            {
              path: "allocate-post/:chapterId",
              exact: true,
              strict: true,
              element: <AllocatePostPage />
            },
            {
              path: "how-to-use-application",
              exact: true,
              strict: true,
              element: <HowToUseApplicationView />
            },
            {
              path: "products",
              exact: true,
              strict: true,
              element: <ProductsRoutes />
            },
            {
              path: "pininmemberlist",
              exact: true,
              strict: true,
              element: <MemberListRoutes />
            },
            {
              path: "sendtype",
              exact: true,
              strict: true,
              element: <SendTypeRoutes />
            },
            {
              path: "citystockreport",
              exact: true,
              strict: true,
              element: <CityStockRoutes />
            },
            {
              path: "pending-stock",
              exact: true,
              strict: true,
              element: <PendingStockRoutes />
            },
            {
              path: "producthistory",
              exact: true,
              strict: true,
              element: <ProductHistoryRoutes />
            },
            {
              path: "pininmember",
              exact: true,
              strict: true,
              element: <PinInMemberRoutes />
            },
            {
              path: "citywallet",
              exact: true,
              strict: true,
              element: <WalletRoutes />
            },
            {
              path: "citywallethistory",
              exact: true,
              strict: true,
              element: <WalletHistoryRoutes />
            },
            {
              path: "traveling",
              exact: true,
              strict: true,
              element: <Traveling />
            },
            {
              path: "leadstatus",
              exact: true,
              strict: true,
              element: <LeadStatus />
            },
            loginUser?.u_type == 0 &&
            loginUser?.is_subadmin == 0 && {
              path: "change-password",
              exact: true,
              strict: true,
              element: <ChangePassword />
            },
            {
              path: "deleted-records",
              exact: true,
              strict: true,
              element: <SystemLog />
            }
          ]
          : // City Amb

          loginUser?.u_type == 1 ||
            (loginUser?.u_type == 2 && loginUser?.management_p != 0) ||
            (loginUser?.u_type == 2 && loginUser?.is_subadmin == 1)
            ? [
              {
                path: "*",
                exact: true,
                strict: true,
                element: <DashboardApp />
              },
              {
                path: "dashboard",
                exact: true,
                strict: true,
                element: <DashboardApp />
              },
              {
                path: "documents",
                exact: true,
                strict: true,
                element: <LvbDocuments />
              },
              {
                path: "memberattendance",
                exact: true,
                strict: true,
                element: <ChapterAttendanceReport />
              },
              {
                path: "lvb-notification",
                exact: true,
                strict: true,
                element: <Notification />
              },
              // Meeting Feedback Report
              {
                path: "meeting-feedback-report",
                exact: true,
                strict: true,
                element: <MeetingFeedbackReport />
              },
              // Renewal Follow-up By LT
              {
                path: "renewal-followup",
                exact: true,
                strict: true,
                element: <RenewalFollowupReport />
              },
              {
                path: "members-v2v-sheet-report",
                exact: true,
                strict: true,
                element: <MembersV2VSheetReport />
              },
              {
                path: "chapter-attendance-report",
                exact: true,
                strict: true,
                element: <ChapterAttendanceReport />
              },
              {
                path: "attendace/:m_id",
                exact: true,
                strict: true,
                element: <Attendace />
              },
              {
                path: "member",
                exact: true,
                strict: true,
                element: <Member />
              },
              {
                path: "wallethistory/:c_a_id",
                exact: true,
                strict: true,
                element: <WalletHistory />
              },
              {
                path: "meeting",
                exact: true,
                strict: true,
                element: <Meeting />
              },
              {
                path: "chapter",
                exact: true,
                strict: true,
                element: <Chapter />
              },
              {
                path: "event-announcement",
                exact: true,
                strict: true,
                element: <Event />
              },
              { path: "v2v", exact: true, strict: true, element: <V2v /> },
              // {
              //   path: "gallery",
              //   exact: true,
              //   strict: true,
              //   element: <Gallery />
              // },
              {
                path: "greeting",
                exact: true,
                strict: true,
                element: <Greeting />
              },
              {
                path: "business",
                exact: true,
                strict: true,
                element: <Business />
              },
              {
                path: "reference",
                exact: true,
                strict: true,
                element: <Reference />
              },
              {
                path: "visitor",
                exact: true,
                strict: true,
                element: <Visitor />
              },
              {
                path: "bankdetail",
                exact: true,
                strict: true,
                element: <Bankdetail />
              },
              {
                path: "change-password",
                exact: true,
                strict: true,
                element: <ChangePassword />
              },
              { path: "poll", exact: true, strict: true, element: <Poll /> },

              {
                path: "staff",
                exact: true,
                strict: true,
                element:
                  loginUser?.u_type != 2 ||
                    (loginUser?.u_type == 2 && loginUser?.is_subadmin == 1) ? (
                    <Staff />
                  ) : (
                    <DashboardApp />
                  )
              },
              {
                path: "paid-invoice",
                exact: true,
                strict: true,
                element: <Invoice />
              },
              {
                path: "quotation-invoice",
                exact: true,
                strict: true,
                element: <Invoice />
              },
              // { path: "staff", element: <Staff /> },
              { path: "followup-leads", exact: true, strict: true, element: <FollowupLeads /> },
              { path: "lead", exact: true, strict: true, element: <Lead /> },
              {
                path: "v2v-report",
                exact: true,
                strict: true,
                element: <V2vReport />
              },
              {
                path: "memberv2vsheet/:member_id",
                exact: true,
                strict: true,
                element: <MemberV2VSheet />
              },
              {
                path: "city-support",
                exact: true,
                strict: true,
                element: <CitySupportList />
              },
              {
                path: "city-support/add",
                exact: true,
                strict: true,
                element: <CitySupportForm />
              },
              {
                path: "city-support/edit/:id",
                exact: true,
                strict: true,
                element: <CitySupportForm />
              },
              {
                path: "business-report",
                exact: true,
                strict: true,
                element: <BusinessReport />
              },
              {
                path: "reference-report",
                exact: true,
                strict: true,
                element: <ReferenceReport />
              },
              {
                path: "visitorreport",
                exact: true,
                strict: true,
                element: <VisitorReport />
              },
              {
                path: "testimonial",
                exact: true,
                strict: true,
                element: <Testimonial />
              },
              {
                path: "testimonial-report",
                exact: true,
                strict: true,
                element: <TestimonialReport />
              },
              {
                path: "attendance-report",
                exact: true,
                strict: true,
                element: <AttendaceReport />
              },
              {
                path: "chapters-member-report",
                exact: true,
                strict: true,
                element: <ChapterMemberReportAllInOne />
              },
              {
                path: "member-induction-report",
                exact: true,
                strict: true,
                element: <MemberInductionReport />
              },
              {
                path: "pin-assign-report",
                exact: true,
                strict: true,
                element: <PinAssignReport />
              },
              {
                path: "topper-report",
                exact: true,
                strict: true,
                element: <GeneralReport />
              },
              {
                path: "city-chapter-report",
                exact: true,
                strict: true,
                element: <CityChapterReport />
              },
              {
                path: "lvb-suggestion",
                exact: true,
                strict: true,
                element: <Suggestion />
              },
              {
                path: "visitor-block-list",
                exact: true,
                strict: true,
                element: <VisitorBlock />
              },
              {
                path: "member-block-list",
                exact: true,
                strict: true,
                element: <MemberBlockList />
              },
              {
                path: "business-approval",
                exact: true,
                strict: true,
                element: <ThankyouNoteApproval />
              },
              {
                path: "traveling",
                exact: true,
                strict: true,
                element: <Traveling />
              },
              {
                path: "training-webinar",
                exact: true,
                strict: true,
                element: <TrainingAndWebinar />
              },
              {
                path: "magazine",
                exact: true,
                strict: true,
                element: <Magazine />
              },
              {
                path: "asks",
                exact: true,
                strict: true,
                element: <Asks />
              },
              {
                path: "v2vlist",
                exact: true,
                strict: true,
                element: <V2VDataList />
              },
              {
                path: "addmgt",
                exact: true,
                strict: true,
                element: <AddMGT />
              },
              {
                path: "obt-add",
                exact: true,
                strict: true,
                element: <OBTAdd />
              },
              {
                path: "obt-apply",
                exact: true,
                strict: true,
                element: <OBTApply />
              },
              {
                path: "routes-view",
                exact: true,
                strict: true,
                element: <RoutesView />
              },
              {
                path: "Products",
                exact: true,
                strict: true,
                element: <ProductsRoutes />
              },
              {
                path: "pininmember",
                exact: true,
                strict: true,
                element: <PinInMemberRoutes />
              },
              {
                path: "pininmemberlist",
                exact: true,
                strict: true,
                element: <MemberListRoutes />
              },
              {
                path: "citywallethistory",
                exact: true,
                strict: true,
                element: <WalletHistoryRoutes />
              },
              {
                path: "allocate-post/:chapterId",
                exact: true,
                strict: true,
                element: <AllocatePostPage />
              },
              {
                path: "deleted-records",
                exact: true,
                strict: true,
                element: <SystemLog />
              }
            ]
            : // Normal USer
            [
              {
                path: "*",
                exact: true,
                strict: true,
                element: <DashboardApp />
              },
              {
                path: "dashboard",
                exact: true,
                strict: true,
                element: <DashboardApp />
              },
              { path: "followup-leads", exact: true, strict: true, element: <FollowupLeads /> },
              { path: "lead", exact: true, strict: true, element: <Lead /> },
              {
                path: "routes-view",
                exact: true,
                strict: true,
                element: <RoutesView />
              },
              {
                path: "deleted-records",
                exact: true,
                strict: true,
                element: <SystemLog />
              }
            ]
    }
  ]);
}

